"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _styles = require("../../styles");

var _getValidObject = _interopRequireDefault(require("../../get-valid-object"));

var _isHexColorValue = _interopRequireDefault(require("../../is-hex-color-value"));

var DEFAULT_ON_ERROR = function DEFAULT_ON_ERROR() {};

var DEFAULT_ON_POINT_CLICK = function DEFAULT_ON_POINT_CLICK() {};

var DEFAULT_SELECTED_POINTS = [];
/**
 * A class to represent the visualization options for a Donut Chart
 * @param {object} options options object (See below)
 * @param {boolean} [options.animate=true] Dictate whether to animate the chart when rendering (True=yes, false=no)
 * @param {boolean} [options.areDataLabelsVisible=false] Dictate whether to show labels on the points of the chart (True=yes, false=no)
 * @param {function} [options.dataLabelFormatter] A function to be passed a value to format data label
 * @param {function} [options.onError] A function to handle an error when rendering
 * @param {function} [options.onLegendClick] A function to handle a legend click
 * @param {function} [options.onPointClick] A function to be passed a point data object (ie percentage, seriesIndex, seriesName, value) on click
 * @param {object[]} [options.selectedIndexPoints] An array of pre selected points
 * @param {String[]} [options.seriesColors] An array of colors for donut slides
 * @param {boolean} [options.showLegend=false] Dictate whether to show legend on the chart (True=yes, false=no)
 * @param {function} [options.tooltipFormatter] Custom handler to format tooltips
 */

var MwChartDonutChartOptions = function MwChartDonutChartOptions(options) {
  (0, _classCallCheck2.default)(this, MwChartDonutChartOptions);
  var safeOptions = (0, _getValidObject.default)(options);

  if (safeOptions.dataLabelFormatter === undefined) {
    safeOptions.dataLabelFormatter = function (_ref) {
      var key = _ref.key;
      return key;
    };
  } else if (typeof safeOptions.dataLabelFormatter !== 'function') {
    throw new TypeError("options.dataLabelFormatter must be a function. Provided value: ".concat(JSON.stringify(safeOptions.dataLabelFormatter)));
  }

  if (safeOptions.onError === undefined) {
    safeOptions.onError = DEFAULT_ON_ERROR;
  } else if (typeof safeOptions.onError !== 'function') {
    throw new TypeError("options.onError must be a function. Provided value: ".concat(safeOptions.onError));
  }

  if (typeof safeOptions.onLegendClick !== 'function' && safeOptions.onLegendClick !== undefined) {
    throw new TypeError("options.onLegendClick must be a function. Provided value: ".concat(safeOptions.onLegendClick));
  }

  if (safeOptions.onPointClick === undefined) {
    safeOptions.onPointClick = DEFAULT_ON_POINT_CLICK;
  } else if (typeof safeOptions.onPointClick !== 'function') {
    throw new TypeError("options.onPointClick must be a function. Provided value: ".concat(safeOptions.onPointClick));
  }

  if (safeOptions.selectedIndexPoints === undefined) {
    safeOptions.selectedIndexPoints = DEFAULT_SELECTED_POINTS;
  } else if (!Array.isArray(safeOptions.selectedIndexPoints) || !safeOptions.selectedIndexPoints.every(function (index) {
    return typeof index === 'number';
  })) {
    throw new TypeError("selectedIndexPoints must be an valid number array. Provided value: ".concat(JSON.stringify(safeOptions.selectedIndexPoints)));
  }

  if (safeOptions.seriesColors === undefined) {
    safeOptions.seriesColors = _styles.DEFAULT_SERIES_CHART_COLORS;
  } else if (!Array.isArray(safeOptions.seriesColors) || !safeOptions.seriesColors.every(function (color) {
    return (0, _isHexColorValue.default)(color);
  })) {
    throw new TypeError("options.seriesColors must be an array of hex colors. Provided value: ".concat(JSON.stringify(safeOptions.seriesColors)));
  }

  if (typeof safeOptions.tooltipFormatter !== 'function' && safeOptions.tooltipFormatter !== undefined) {
    throw new TypeError("options.tooltipFormatter must be a function. Provided value: ".concat(JSON.stringify(safeOptions.tooltipFormatter)));
  }

  this.animate = safeOptions.animate !== false;
  this.areDataLabelsVisible = safeOptions.areDataLabelsVisible !== false;
  this.dataLabelFormatter = safeOptions.dataLabelFormatter;
  this.onError = safeOptions.onError;
  this.onLegendClick = safeOptions.onLegendClick;
  this.onPointClick = safeOptions.onPointClick;
  this.selectedIndexPoints = safeOptions.selectedIndexPoints;
  this.seriesColors = safeOptions.seriesColors;
  this.showLegend = Boolean(safeOptions.showLegend);
  this.tooltipFormatter = safeOptions.tooltipFormatter;
  Object.freeze(this);
};

exports.default = MwChartDonutChartOptions;